<template lang="pug">
  div
    .buttons.buttons-tabs
      router-link.btn.btn-primary(v-for="(tab, index) in preparedPageTabs", :key="index",
        :to="{name: tab.link}"
      ) {{ tab.name }}
    router-view
</template>

<script>

export default {
  data() {
    return {
      pageTabs: [
        {
          name: 'FBA shipment',
        },
        {
          name: 'FBM shipment',
        },
      ],
      shipments: [],
    };
  },
  computed: {
    user_role() {
      return this.$store.state.users.role;
    },
    chosen_client() {
      return this.$store.state.users.chosen_client;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    preparedPageTabs() {
      return this.pageTabs.map((tab) => {
        tab.link = `${this.app_section}-processing-${tab.name.split(' ').join('-').toLowerCase()}`;
        return tab;
      });
    },
  },
  created() {
    if (['admin', 'worker'].indexOf(this.user_role) !== -1 && !this.chosen_client) {
      this.$router.push({ name: `${this.app_section}-clients` });
    }
  },
};
</script>
